import React, { Fragment } from 'react'
import MenuItem from './MenuItem'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'

const SubMenu = ({ items, type, parentLabel, indexParent, indexItem, hideSubmenu, path }) => {
  return (
    <Fragment>
      <MediaQuery maxWidth={1024}>
        <Fragment>
          <ul>
            <li className='close-hamburger-menu bg-brand-4 color-ui-white px-2 mb-1'>
              <a
                onClick={() => hideSubmenu()}
                className={`mn-item color-ui-white fechar-menu d-flex align-items-center`}
                tabIndex={0}
              >
                <i className='icon icon_left_app color-ui-white mr-1' aria-hidden='true' />
                { parentLabel }
              </a>
            </li>
          </ul>
          <div className='scroll-mobile'>
            <ul>
              { items.map((item, index) => {
                return (
                  <li className='txt-left p-0 m-0 pos-initial'>
                    <MenuItem
                      key={index}
                      indexParent={indexParent}
                      indexItem={indexItem}
                      type={item.type || type}
                      {...item}
                    />
                  </li>
                )
              }) }
              { path && <li className='subitems-seeall row mx-0 px-2 pt-2 pb-1'>
                <div className='col'>
                  <Link
                    to={path}
                    className={`link-profile txt-body d-block`}
                    aria-label={`Ver todos os itens.`}
                  >
                    Ver todos os itens
                    <span className='hide-absolute'>Ver todos os itens.</span>
                  </Link>
                </div>
                <div className='col-auto'>
                  <Icon iconName='icon_right' className='ver-todos icon-sm' />
                </div>
              </li> }
            </ul>
          </div>
        </Fragment>
      </MediaQuery>
      <MediaQuery minWidth={1025}>
        <li className='row px-0 mx-0'>
          <div className='col-12'>
            <div className='subitems-title ver-todos row mx-0 pb-2 pt-1 mb-2 border-bottom border-color-ui-3'>
              <div className='col-auto'>
                <Icon iconName='icon_left' className='icon-ssm ver-todos' />
              </div>
              <div className='col'>
                <button
                  className={`link-profile txt-body d-block txt-font-body-bold`}
                  onClick={() => hideSubmenu()}
                  aria-label='Fechar sub-menu'
                >
                  { parentLabel }
                </button>
              </div>
            </div>
            <div className='subitems-box w-100 mx-half' tabIndex={-1}>
              { items.map((item, index) => {
                return (
                  <MenuItem
                    key={index}
                    indexParent={indexParent}
                    indexItem={indexItem}
                    type={item.type || type}
                    {...item}
                  />
                )
              }) }
            </div>
            { path && <div className='subitems-seeall  row mx-0 px-2 pt-2 pb-1 mt-2 border-top border-color-ui-3'>
              <div className='col'>
                <Link
                  to={path}
                  className={`link-profile txt-body d-block txt-font-body-bold`}
                  aria-label={`Ver todos os itens.`}
                >
                  Ver todos os itens
                  <span className='hide-absolute'>Ver todos os itens.</span>
                </Link>
              </div>
              <div className='col-auto'>
                <Icon iconName='icon_right' className='ver-todos icon-sm color-brand-4' />
              </div>
            </div>
            }
          </div>
        </li>
      </MediaQuery>
    </Fragment>
  )
}

SubMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(MenuItem.propTypes)).isRequired,
  type: PropTypes.string,
  parentLabel: PropTypes.string,
  path: PropTypes.string,
  indexParent: PropTypes.number,
  indexItem: PropTypes.number,
  hideSubmenu: PropTypes.func
}

export default SubMenu



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuItem/SubMenu.js